import React from 'react';

const CookiePopup = ({ isOpen, onClose, content }) => {
    if (!isOpen) return null;



    return (
        <div className="chat_box_popup_cookie" >
            <div className="cookie_popup">
                <button className="cookie-close" onClick={() => onClose} > &times;</button>
                <div className="iframe-container" onClick={() => onClose}>

                    <iframe
                        src={content}
                        width='100%'
                        height='100%'
                        style={{ border: 'none', borderRadius: '10px' }}
                        title="Content"
                    />
                </div>
            </div>
        </div>
    );
};

export default CookiePopup;
